var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtractionreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19755 14.548C9.7464 14.548 11.002 13.2924 11.002 11.7435C11.002 10.1947 9.7464 8.93909 8.19755 8.93909C6.64871 8.93909 5.39313 10.1947 5.39313 11.7435C5.39313 13.2924 6.64871 14.548 8.19755 14.548Z",
    stroke: "white",
    strokeWidth: 1.31458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5278 15.0738L10.6514 14.1974",
    stroke: "white",
    strokeWidth: 1.31458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2804 8.76388V13.1458C19.2804 17.5277 17.5277 19.2805 13.1457 19.2805H7.88743C3.50551 19.2805 1.75275 17.5277 1.75275 13.1458V7.88749C1.75275 3.50558 3.50551 1.75281 7.88743 1.75281H12.2694",
    stroke: "white",
    strokeWidth: 1.31458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2804 8.76388H15.7749C13.1457 8.76388 12.2693 7.88749 12.2693 5.25834V1.75281L19.2804 8.76388Z",
    stroke: "white",
    strokeWidth: 1.31458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractionreview);
export default __webpack_public_path__ + "static/media/extraction review.099e388ab390109bad9418df403041e7.svg";
export { ForwardRef as ReactComponent };